import styled from '@emotion/styled';
import { docGeniusPalette } from 'styles/partials/colors';

export const Container = styled.div({
  display: 'flex',
  margin: '4px',
  columnGap: '8px',
});

export const Wrapper = styled.div({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  margin: '4px 0',
});

export const Radio = styled.input({
  backgroundColor: docGeniusPalette.primaryBlue,
  color: docGeniusPalette.primaryBlue,
  height: '20px',
  marginRight: '8px',
  width: '20px',
});
